import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { RoleKey } from 'modules/auth/core/enum';

import { checkRole } from 'helpers';
import withPermission from 'hooks/withPermission';

import { PATH } from 'constants/path';

import { DashboardLayout } from './components/DashboardLayout';
import { CoursesPage, ExercisesPage, LessonsPage } from './pages';
import AddAssessmentPage from './pages/AddAssessmentPage';
import { AddCoursePage } from './pages/AddCoursePage';
import { AddExercisesPage } from './pages/AddExercisesPage';
import AddFunctionalTestPage from './pages/AddFunctionalTestPage';
import { AddLessonPage } from './pages/AddLessonPage';
import AssessmentsPage from './pages/AssessmentsPage';
import FunctionalTestsPage from './pages/FunctionalTestsPage';

const DashboardRoutes = () => {
  const location = useLocation();

  const isExercisePage = location.pathname.includes(PATH.EXERCISES);

  return (
    <Routes>
      <Route
        element={
          <DashboardLayout
            hideAddButton={
              isExercisePage && checkRole([RoleKey.TRAINER_INSTITUTION, RoleKey.TRAINER_BIOLOGIC])
            }
          />
        }
      >
        <Route path={PATH.EXERCISES} element={<ExercisesPage />} />
        <Route path={PATH.LESSONS} element={<LessonsPage />} />
        <Route path={PATH.COURSES} element={<CoursesPage />} />
        <Route path={PATH.FUNCTIONAL_TESTS} element={<FunctionalTestsPage />} />
        <Route path={PATH.ASSESSMENTS} element={<AssessmentsPage />} />
        <Route index element={<Navigate to={PATH.EXERCISES} />} />
      </Route>
      <Route path={`${PATH.EXERCISES}/${PATH.ADD_EXERCISES}`} element={<AddExercisesPage />} />
      <Route path={`${PATH.EXERCISES}/${PATH.EDIT_EXERCISES}`} element={<AddExercisesPage />} />
      <Route path={`${PATH.LESSONS}/${PATH.ADD_LESSONS}`} element={<AddLessonPage />} />
      <Route path={`${PATH.LESSONS}/${PATH.EDIT_LESSONS}`} element={<AddLessonPage />} />
      <Route path={`${PATH.COURSES}/${PATH.ADD_COURSES}`} element={<AddCoursePage />} />
      <Route path={`${PATH.COURSES}/${PATH.EDIT_COURSES}`} element={<AddCoursePage />} />
      <Route
        path={`${PATH.FUNCTIONAL_TESTS}/${PATH.ADD_FUNCTIONAL_TESTS}`}
        element={<AddFunctionalTestPage />}
      />
      <Route
        path={`${PATH.FUNCTIONAL_TESTS}/${PATH.EDIT_FUNCTIONAL_TESTS}`}
        element={<AddFunctionalTestPage />}
      />

      <Route path={`${PATH.ASSESSMENTS}/${PATH.ADD_ASSESSMENTS}`} element={<AddAssessmentPage />} />
      <Route
        path={`${PATH.ASSESSMENTS}/${PATH.EDIT_ASSESSMENTS}`}
        element={<AddAssessmentPage />}
      />
      <Route path="*" element={<Navigate to={PATH.ERROR_404} />} />
    </Routes>
  );
};

export default withPermission(['Library'])(DashboardRoutes);
